import { success, error, loading } from 'State/actions';
import * as types from './types';

const resourceName = 'InvGroup/TaxGroup';

export const getTaxGroupSetup = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.TAXGROUP_SETUP_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(resourceName);
      dispatch(success(types.TAXGROUP_SETUP_GET, response));
    } catch (ex) {
      dispatch(error(types.TAXGROUP_SETUP_ERROR, ex));
    } finally {
      dispatch(loading(types.TAXGROUP_SETUP_LOADING, false));
    }
  };
};

export const taxGroupSetupDelete = id => {
  return (dispatch, getState, MPWWebApi) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(loading(types.TAXGROUP_SETUP_LOADING, true));
        const response = await MPWWebApi.postGenericDelete(resourceName, id);
        dispatch(getTaxGroupSetup(resourceName));
        dispatch(loading(types.TAXGROUP_SETUP_LOADING, false));
        resolve(response);
      } catch (error) {
        dispatch({
          type: types.TAXGROUP_SETUP_ERROR,
          payload: error.response,
        });
        dispatch(loading(types.TAXGROUP_SETUP_LOADING, false));
        reject();
      }
    });
  };
};

export const taxGroupSetupInsertUpdate = taxGroupSetup => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.TAXGROUP_SETUP_LOADING, true));

    return new Promise((resolve, reject) => {
      MPWWebApi.postGenericInsertUpdate(resourceName, taxGroupSetup)
        .then(response => {
          //Reload roles from the DB
          dispatch(getTaxGroupSetup(resourceName));
          dispatch(loading(types.TAXGROUP_SETUP_LOADING, false));
          resolve(response);
        })
        .catch(error => {
          dispatch({
            type: types.TAXGROUP_SETUP_ERROR,
            payload: error.response,
          });
          //Reload roles from the DB
          dispatch(getTaxGroupSetup(resourceName));
          dispatch(loading(types.TAXGROUP_SETUP_LOADING, false));
          reject(error.response);
        });
    });
  };
};

export const clearTaxGroupSetupData = () => {
  return {
    type: types.TAXGROUP_SETUP_CLEAR,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/taxgroupsetup/state/actions.js